export enum OptInEvent {
	ACCEPT = 'accept',
	DENY = 'deny',
	DISMISS = 'dismiss',
	IMPRESSION = 'impression',
}